import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { UntilDestroy } from '@ngneat/until-destroy';

import { TimeZonesApiService } from '@blaze-shared/platform-data-access';
import { SelectComponent } from '@blaze-shared/shared-feature';
import { safeDetectChanges } from '@blaze-shared/shared-ui';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-timezone',
  templateUrl: './cell-input-timezone.component.html',
  styleUrls: ['./cell-input-timezone.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent, MatIcon, AsyncPipe],
})
export class CellInputTimezoneComponent extends BaseCellInputComponent<string> {
  private readonly timeZonesApiService = inject(TimeZonesApiService);

  @Input() readonly = false;

  @ViewChild('timezoneSelector') timezoneSelectorRef!: ElementRef<HTMLInputElement>;
  @ViewChild(SelectComponent) timezoneSelector!: SelectComponent;

  availableTimeZones$ = this.timeZonesApiService.timeZones$;

  override get nativeElement(): HTMLInputElement | null {
    return this.timezoneSelectorRef?.nativeElement || null;
  }

  setTimezone(value: string | string[]): void {
    if (!value) {
      value = '';
    }
    if (Array.isArray(value)) {
      this.emitValueChanged(value[0]);
      this.formControl.patchValue(value[0]);
    } else {
      this.emitValueChanged(value);
      this.formControl.patchValue(value);
    }
    safeDetectChanges(this.cdr);
  }

  override executeExtraStartAction(): void {
    if (this.extraStartAction?.type === 'timezone-add') {
      setTimeout(() => {
        this.timezoneSelector.showOptions();
      });
    } else if (this.extraStartAction?.type === 'timezone-remove') {
      this.setTimezone('');
      this.timezoneSelector.showOptions();
    }
  }
}
